export const version = "transactions/5.0.9";
//# sourceMappingURL=_version.js.map